<!-- 
  跟进业务
 -->

<template>
  <div class="comBusiness" v-clickoutside="hide">
    <el-input :placeholder="form && form[item.attr].id ? '' : '选择业务' "  readonly  @focus="showComBusinessBox = !showComBusinessBox"></el-input>
    <span class="item" v-if="form && form[item.attr].id" >
      <span class="text">{{form[item.attr].value}}</span>
      <i class="del el-icon-close" @click="del()"></i>
    </span>
    <span class="rightIcon"
      :class="[showComBusinessBox? 'el-icon-caret-bottom' : 'el-icon-caret-top']"
      @click.stop="showComBusinessBox = !showComBusinessBox">
    </span>
    <div class="comBusinessBox" v-if="showComBusinessBox">
      <ul class="listBusiness">
        <li class="liBusines" v-for="item in listData" :key="item.id" @click="selectList(item)">
          <el-tooltip
            effect="light"
            :content="item.value"
            placement="top-start">
            <span>{{item.value}}</span>
          </el-tooltip>
        </li>
        <li class="liBusines" v-if="!listData.length">无</li>
      </ul>
      <ul class="tagBusiness">
        <li class="tag" v-for="value in item.selectControl.valueArrMap" :key="value.key" v-if="value.enable" :class="{'active': value.key === key}" @click="toggleType(value.key)">{{value.value}}</li>
        <li class="tag" v-if="!item.selectControl.valueArrMap.length">无</li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'
import Clickoutside from 'element-ui/lib/utils/clickoutside'

export default {
  created () {
    this.getSelectList()
  },
  props: {
    customerId: {
      type: Number
    },
    form: {
      type: Object
    },
    item: {
      type: Object
    }
  },
  data () {
    return {
      showComBusinessBox: false,
      listData: [],
      key: this.item.selectControl && this.item.selectControl.attrValue ? this.item.selectControl.attrValue : 5
    }
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    getSelectList () {
      let url
      if (this.key === 5) {
        url = `/opportunityApi/getOpportunitys.html`
      } else {
        url = `/contractApi/getContractList.html`
      }
      let params = {
        page: 1,
        pageSize: 10,
        customerId: this.customerId
      }
      api.post(url, params, (data) => {
        this.listData = data.result
      })
    },
    toggleType (key) {
      this.key = key
      this.getSelectList()
    },
    selectList (obj) {
      this.form[this.item.attr] = {id: obj.id, value: obj.value, key: this.key}
      this.setAttr(this.item.attr)
      this.showComBusinessBox = false
    },
    del () {
      this.form[this.item.attr] = ''
      this.setAttr(this.item.attr)
    },
    hide () {
      this.showComBusinessBox = false
    }
  },
  watch: {
  },
  directives: { Clickoutside }
}
</script>

<style lang="less" scoped>
.comBusiness {
  position: relative;
  .item {
    position: absolute;
    top: 3px;
    color: #20a0ff;
    height: 24px;
    line-height: 22px;
    box-sizing: border-box;
    margin: 3px 0 3px 6px;
    background-color: rgba(32, 160, 255, 0.1);
    border: 1px solid rgba(32, 160, 255, 0.2);
    display: inline-block;
    padding: 0 5px;
    font-size: 12px;
    border-radius: 4px;
    white-space: nowrap;
    .text {
      display: inline-block;
      max-width: 120px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      vertical-align: top;
    }
    .del {
      border-radius: 50%;
      text-align: center;
      position: relative;
      cursor: pointer;
      font-size: 12px;
      transform: scale(0.75);
      height: 18px;
      width: 18px;
      line-height: 18px;
      vertical-align: middle;
      top: -1px;
      right: -2px;
      transition: all 0.2s;
      &:hover {
        background-color: #20a0ff;
        color: #fff;
      }
    }
  }
  .rightIcon {
    position: absolute;
    top: 16px;
    right: 13px;
    color: rgb(191, 203, 217);
    font-size: 12px;
    transition: transform .3s;
    transform: translateY(-50%) rotateZ(180deg);
    line-height: 16px;
    cursor: pointer;
  }
  .comBusinessBox {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0px;
    background: #fff;
    border-radius: 2px;
    border: 1px solid rgb(191, 203, 217);
    z-index: 100;
    height: 200px;
    .listBusiness{
      height: 100%;
      padding: 0 10px;
      overflow: auto;
      .liBusines {
        display: inline-block;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        vertical-align: top;
        cursor: pointer;
      }
    }
    .tagBusiness {
      position: absolute;
      top: -1px;
      left: -72px;
      background: #fff;
      .tag {
        width: 70px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        border: 1px solid rgb(191, 203, 217);
        &:last-child {
          border-top: 0;
        }
        &:first-child {
          border-top: 1px solid rgb(191, 203, 217);
        }
        &.active {
          border-right: 0;
          width: 71px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// communicate-business.vue?42c969f1